<template>
  <div
    :class="pulseClasses"
    class="outline-none border-skeleton border-solid border-2 rounded-5 cursor-default select-none"
    aria-hidden="true"
    data-test="container"
  >
    <div class="bg-skeleton h-xl"></div>
    <div class="p-twenty flex flex-col gap-twenty">
      <TextSkeleton :characters="25" />
      <hr class="my-0" />
      <TextSkeleton :characters="25" />
      <hr class="my-0" />
      <TextSkeleton :characters="25" />
      <hr class="my-0" />
      <TextSkeleton :characters="25" />
      <hr class="my-0" />
      <ButtonSkeleton class="w-full mb-base" />
    </div>
  </div>
</template>

<script>
import ButtonSkeleton from '@/components/library/skeletons/ButtonSkeleton.vue';
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';

export default {
  name: 'WidgetSkeleton',
  components: {
    ButtonSkeleton,
    TextSkeleton,
  },
  props: {
    /**
     * When pulse is true and used within another skeleton
     * component, the pulsing increases.
     *
     * If this component is used on its own somewhere, it won't
     * pulse unless this is true.
     */
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    pulseClasses() {
      return {
        'animate-pulse': this.pulse,
      };
    },
  },
};
</script>
